import { SERVER } from './../environment.constants';
export class DroneSpecificationURL {
    public static droneSpecifiation: string = SERVER + "/droneSpec"
    public static manufacturerList: string = DroneSpecificationURL.droneSpecifiation + "/manufacturer";
    public static droneList = (manufacturerName: string) => 
        `${DroneSpecificationURL.manufacturerList}/${manufacturerName}`;
}